module.exports = __webpack_public_path__ + "img/insights_black_24dp.4a192c87.svg";